import React, { useEffect, useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import SignedInNavbarImproved from "../../SignedInNavbarImproved";
import Container from "../my_container/Container";
import PepperImage from "../../../assets/pepperImage.png";
import ReturnSuccessImage from "../../../assets/returnSuccessImage.png";
import { useRef } from "react";
import { CloudArrowUpIcon } from "@heroicons/react/24/solid";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { IoCheckmarkCircle } from "react-icons/io5";

const requestReturnlist = [
  { id: 1, reqImage: PepperImage, itemName: "Item Name 1", price: "120,000", description: ["Rice 10kg","Big", "medium", "tiny x10"]},
  { id: 2, reqImage: PepperImage, itemName: "Item Name 2", price: "80,000", description: ["Beans 5kg","small", "x5"]},
  { id: 3, reqImage: PepperImage, itemName: "Item Name 3", price: "60,000", description: ["Pepper basket"]},
  { id: 4, reqImage: PepperImage, itemName: "Item Name 4", price: "45,000", description: ["Tomato box"]},
  { id: 5, reqImage: PepperImage, itemName: "Item Name 5", price: "55,000", description: ["Tomato box"]},
  { id: 6, reqImage: PepperImage, itemName: "Item Name 6", price: "75,000", description: ["Tomato box"]},
];

const RequestReturnsComponent = ({ id, reqImage, itemName, description, price, checked, onToggle }) => {
  // Wrap the whole card in a label so clicking anywhere toggles the checkbox exactly once.
  return (
    <label
      htmlFor={`return-policy-${id}`}
      className="flex items-center space-x-2 mb-4 p-4 border border-gray-200 rounded-md bg-[#F9F9F9] hover:shadow cursor-pointer transition duration-300"
    >
      <div>
        <input
          id={`return-policy-${id}`}
          type="checkbox"
          checked={checked}
          onChange={() => onToggle(id)}
          className="h-5 w-5 rounded-sm cursor-pointer border border-gray-300
            checked:bg-[#558223] checked:border-[#558223]
            focus:outline-none focus:ring-0"
        />
      </div>

      <div className="h-20 w-20 flex items-center justify-center rounded-md bg-[#F5F0F0] flex-shrink-0 ">
        <img
          src={reqImage ? reqImage : PepperImage}
          alt="product"
          className="w-16 h-16 object-cover "
        />
      </div>

      <div className="flex flex-col flex-1 ml-4">
        <div className="text-sm font-medium text-gray-700">{itemName || "Product Name"}</div>
        <div className="text-sm text-gray-500">
          {Array.isArray(description) ? description.join("/ ") : description}
        </div>
        <div className="text-sm font-bold text-gray-600 mt-2">N{price || "N 23,000.00"}</div>
      </div>
    </label>
  );
};

const RequestReturnsPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const stepFromUrl = parseInt(searchParams.get("step") || "0", 10);
  const [currentStep, setCurrentStep] = useState(stepFromUrl);
  const [selectedItems, setSelectedItems] = useState([]); // Track selected item IDs
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    console.log("Selected files:", files);
  };

  const steps = ["step one", "step two"];

  // keep query param in sync whenever currentStep changes
  useEffect(() => {
    setSearchParams({ step: currentStep.toString() });
  }, [currentStep, setSearchParams]);

  const handleNext = () => setCurrentStep((prev) => prev + 1);
  const handlePrev = () => setCurrentStep((prev) => prev - 1);

  const toggleItem = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
    );
  };

  const Dynamicbutton = () => {
    return (
      <div
        className={`mt-6 mb-40 flex items-center ${
          currentStep > 0 ? "justify-between" : "justify-end"
        }`}
      >
        {currentStep > 0 && (
          <button
            type="button"
            onClick={handlePrev}
            className="w-full max-w-[120px] flex flex-row items-center justify-center space-x-2 py-2.5 bg-white text-[#558223] font-medium ring-[1.5px] ring-[#558223] hover:bg-[#558223]/5 rounded-md"
          >
            Back
          </button>
        )}

        {currentStep < steps.length - 1 ? (
          <button
            type="button"
            onClick={handleNext}
            className="w-full max-w-[120px] flex items-center justify-center py-2.5 bg-[#558223] text-white font-medium hover:text-[#558223] hover:bg-transparent ring-[1.5px] ring-[#558223] hover:ring-[#558223] rounded-md"
          >
            Proceed
          </button>
        ) : (
          <button
            onClick={() => setIsOpen(true)}
            type="submit"
            className="w-full max-w-[120px] flex items-center justify-center py-2.5 bg-[#558223] text-white font-medium hover:text-[#558223] hover:bg-transparent ring-[1.5px] ring-[#558223] hover:ring-[#558223] rounded-md"
          >
            Submit
          </button>
        )}
      </div>
    );
  };

  return (
    <>
      <SignedInNavbarImproved />
      <div className="min-h-screen max-w-[1500px] mx-auto bg-[#F9F9F9] @container">
        <div className="w-full">
          {currentStep === 0 && (
            <Container className="pt-8 pb-8">
              <div className="mb-8">
                <div className="flex items-center space-x-2 sm:space-x-4">
                  <div
                    onClick={() => navigate(-1)}
                    className="rounded-full p-1 hover:bg-gray-200"
                  >
                    <BiArrowBack className="h-6 w-6 cursor-pointer text-gray-600" />
                  </div>
                  <h1 className="text-lg font-bold text-gray-700 sm:text-2xl">
                    Order Details; Request Returns
                  </h1>
                </div>
              </div>
              <div className="flex items-center space-x-20">
                <span>Select the items you would like to Return</span>
                <span className="text-[#558223] font-medium">
                  Step {currentStep + 1} of {steps.length}
                </span>
              </div>
              <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {requestReturnlist.map((item) => (
                  <RequestReturnsComponent
                    key={item.id}
                    id={item.id}
                    reqImage={item.reqImage}
                    itemName={item.itemName}
                    description={item.description}
                    price={item.price}
                    checked={selectedItems.includes(item.id)}
                    onToggle={toggleItem}
                  />
                ))}
              </div>
              <Dynamicbutton />
            </Container>
          )}

          {currentStep === 1 && (
            <div className="w-full grid md:grid-cols-3 gap-4 pl-4 sm:pl-8 md:pl-14">
              <div className="md:col-span-2 pr-4">
                <div className="flex-1 mt-8 max-w-xl pb-20">
                  <div className="mb-8">
                    <div className="flex items-center space-x-2 sm:space-x-4">
                      <div
                        onClick={() => navigate(-1)}
                        className="rounded-full p-1 hover:bg-gray-200"
                      >
                        <BiArrowBack className="h-6 w-6 cursor-pointer text-gray-600" />
                      </div>
                      <h1 className="text-lg font-bold text-gray-700 sm:text-2xl">
                        Order Details; Request Returns
                      </h1>
                    </div>
                  </div>
                  <div className="flex items-center space-x-20">
                    <span>Tell us more about the issue</span>
                    <span className="text-[#558223] font-medium">
                      Step {currentStep + 1} of {steps.length}
                    </span>
                  </div>
                  <div className="mt-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Why are you returning these items?
                      </label>
                      <select
                        className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 
                                  focus:outline-none focus:ring-1 focus:ring-[#558223] focus:border-[#558223] 
                                  hover:border-[#558223]/70 transition"
                        defaultValue=""
                      >
                        <option value="" disabled>
                          -- Select an option --
                        </option>
                        <option value="option1">Damaged/broken Items</option>
                        <option value="option2">Wrong item sent</option>
                        <option value="option3">Poor quality</option>
                        <option value="option4">Expired/spoiled Items</option>
                        <option value="option5">Other</option>
                      </select>
                    </div>
                    <div className="mt-6 w-full">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Add photos (recommended)
                      </label>

                      <div
                        onClick={handleClick}
                        className="flex flex-col items-center justify-center w-full h-40 
                                  border-2 border-dashed border-[#558223] rounded-lg cursor-pointer 
                                  bg-[#F9F9F9] hover:bg-[#f0fdf4] transition"
                      >
                        <CloudArrowUpIcon className="h-10 w-10 text-[#558223]/80 mb-2" />
                        <p className="text-sm font-medium text-[#558223]">
                          Tap to add photos of the item
                        </p>
                        <p className="text-xs text-gray-500">or drag and drop it here</p>

                        <input
                          type="file"
                          multiple
                          ref={fileInputRef}
                          onChange={handleFileChange}
                          className="hidden"
                        />
                      </div>
                    </div>
                    <div className="mt-6">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Additional comments (optional)
                      </label>
                      <textarea
                        rows={4}
                        placeholder="Tell us more about what happened"
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 
                                  placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-[#558223] 
                                  focus:border-[#558223] hover:border-[#558223]/70 transition"
                      ></textarea>
                    </div>
                  </div>
                  <div className="hidden md:block">
                  <Dynamicbutton />
                  </div>
                </div>
              </div>

              <div className="md:col-span-1 min-h-screen shrink-0 bg-white px-4 pt-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold text-gray-600 sm:text-xl">Selected Items for Return</h3>
                  <button
                    onClick={() => setCurrentStep(0)}
                    className="text-sm font-medium text-[#558223] hover:underline hover:underline-offset-2 decoration-[1.5px]"
                  >
                    Edit
                  </button>
                </div>
                <div className="mt-6 space-y-4">
                  {requestReturnlist
                    .filter((item) => selectedItems.includes(item.id))
                    .map((item) => (
                      <div
                        key={item.id}
                        className="flex items-center space-x-3 border-b-4 border-gray-100 pb-3"
                      >
                        <div>
                          <input
                            type="checkbox"
                            checked={selectedItems.includes(item.id)} // controlled ✅
                            onChange={() => toggleItem(item.id)}     // keep in sync ✅
                            className="h-4 w-4 rounded-sm cursor-pointer border border-gray-300
                              checked:bg-[#558223] checked:border-[#558223]
                              focus:outline-none focus:ring-0"
                          />
                        </div>
                        <div className="h-14 w-14 flex items-center justify-center rounded-md bg-[#F5F0F0] flex-shrink-0 ">
                          <img
                            src={item.reqImage}
                            alt="selected"
                            className="w-11 h-11 rounded-md object-cover"
                          />
                        </div>
                        <div>
                          <div className="text-sm font-medium text-gray-700">{item.itemName}</div>
                          <div className="text-sm font-medium text-gray-700">
                            {Array.isArray(item.description)
                              ? item.description.join(", ")
                              : item.description}
                          </div>
                          <div className="text-xs text-gray-500">N{item.price}</div>
                        </div>
                      </div>
                    ))}
                  {selectedItems.length === 0 && (
                    <p className="text-sm text-gray-500">No items selected</p>
                  )}
                </div>
                <div className="mt-10 md:hidden">
                  <Dynamicbutton />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div>
        <Transition.Root show={isOpen} as={Fragment}>
          <Dialog as="div" className="relative z-50" onClose={() => setIsOpen(false)}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black/40 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-50 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center overflow-hidden">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-200"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative w-full max-w-xl transform rounded-xl bg-white p-6 shadow-xl transition-all max-h-[96vh] overflow-y-auto">
                    {/* Header */}
                    {isSubmitted ? (
                        <>
                          <div className="flex justify-end items-center pb-3">
                            <button
                              type="button"
                              onClick={() => setIsOpen(false)}
                              className="rounded-full p-1 text-gray-400 hover:text-gray-600"
                            >
                              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                            </button>
                          </div>
                          <div className="flex items-center justify-center">
                            <img src={ReturnSuccessImage} alt="success" className="h-28 w-28 aspect-auto object-contain"/>
                          </div>
                          <div className="text-center pb-2">
                            <h2 className="text-2xl font-semibold text-gray-600 mb-4">Success! You've Submitted your Returns Request!</h2>
                            <p className="text-gray-600 mb-6">Thanks for letting us know about the issue. Our team will take a look and get back to you soon. We'll email you updates as we proceed.</p> 
                          </div>
                          <button onClick={() => navigate("/returns-policy/request-status")} className="mx-auto mb-4 w-fit px-8 flex items-center justify-center py-2 bg-[#558223] text-white font-medium hover:text-[#558223] hover:bg-transparent ring-[1.5px] ring-[#558223] hover:ring-[#558223] rounded-md">
                            View return status
                          </button>
                        </>

                      ) : (
                      <>
                        <div className="flex justify-between items-center border-b pb-3">
                          <Dialog.Title className="text-lg font-semibold text-gray-900">
                            Review your Returns Request
                          </Dialog.Title>
                          <button
                            type="button"
                            onClick={() => setIsOpen(false)}
                            className="rounded-full p-1 text-gray-400 hover:text-gray-600"
                          >
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>

                        {/* Body */}
                        <div className="mt-4 space-y-6 text-sm text-gray-700">
                          {/* Resolution */}
                          <div>
                            <h3 className="font-medium text-gray-900">Resolution Method</h3>
                            <p className="text-gray-600 mt-1">Item Replacement</p>
                          </div>

                          {/* Reasons */}
                          <div>
                            <div className="flex justify-between items-center">
                              <h3 className="font-medium text-gray-900">Reasons Provided for Returns</h3>
                              <button className="text-green-700 text-sm font-medium">Edit</button>
                            </div>
                            <ul className="mt-2 list-disc list-inside space-y-1 text-gray-600">
                              <li>Damaged/broken Item</li>
                              <li>Wrong item sent</li>
                              <li>Poor quality</li>
                              <li>Expired/spoiled Items</li>
                              <li>Other</li>
                            </ul>
                            <p className="mt-2 text-gray-600">
                              <span className="font-medium">Other (Specification):</span>{" "}
                              Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut enim ad minim veniam…
                            </p>
                          </div>

                          {/* Photos */}
                          <div>
                            <h3 className="font-medium text-gray-900">Photo Provided</h3>
                            <div className="mt-2 flex space-x-2">
                              {[...Array(5)].map((_, i) => (
                                <div
                                  key={i}
                                  className="h-16 w-16 rounded-md bg-gray-300 flex items-center justify-center"
                                />
                              ))}
                            </div>
                          </div>

                          {/* Additional Comments */}
                          <div>
                            <h3 className="font-medium text-gray-900">Additional Comments</h3>
                            <p className="mt-1 text-gray-600">I am really disappointed, I expected better</p>
                            <p className="mt-2 text-green-700 font-semibold">OR</p>
                            <p className="text-gray-600">None</p>
                          </div>

                          {/* Items */}
                          <div>
                            <div className="flex justify-between items-center">
                              <h3 className="font-medium text-gray-900">Selected items for return</h3>
                              <button className="text-green-700 text-sm font-medium">Edit</button>
                            </div>
                            <ul className="mt-4 space-y-3">
                              {/* {[1, 2, 3, 4, 5].map((id) => (
                                <li
                                  key={id}
                                  className="flex items-center space-x-3 rounded-md border p-2"
                                >
                                  <input type="checkbox" checked readOnly className="accent-green-600" />
                                  <img
                                    src={PepperImage}
                                    alt="item"
                                    className="h-12 w-12 rounded object-cover"
                                  />
                                  <div>
                                    <p className="text-sm font-medium">Item Name</p>
                                    <p className="text-xs text-gray-500">Rice 10kg (x10)</p>
                                    <p className="text-xs text-gray-500">₦120,000</p>
                                  </div>
                                </li>
                              ))} */}
                                                {requestReturnlist
                            .filter((item) => selectedItems.includes(item.id))
                            .map((item) => (
                              <div
                                key={item.id}
                                className="flex items-center space-x-3 rounded-md border border-gray-200 p-4"
                              >
                                <div>
                                  <input
                                    type="checkbox"
                                    checked={selectedItems.includes(item.id)} // controlled ✅
                                    onChange={() => toggleItem(item.id)}     // keep in sync ✅
                                    className="h-4 w-4 rounded-sm cursor-pointer border border-gray-300
                                      checked:bg-[#558223] checked:border-[#558223]
                                      focus:outline-none focus:ring-0"
                                  />
                                </div>
                                <div className="h-14 w-14 flex items-center justify-center rounded-md bg-[#F5F0F0] flex-shrink-0 ">
                                  <img
                                    src={item.reqImage}
                                    alt="selected"
                                    className="w-11 h-11 rounded-md object-cover"
                                  />
                                </div>
                                <div>
                                  <div className="text-sm font-medium text-gray-700">{item.itemName}</div>
                                  <div className="text-sm font-medium text-gray-700">
                                    {Array.isArray(item.description)
                                      ? item.description.join(", ")
                                      : item.description}
                                  </div>
                                  <div className="text-xs text-gray-500">N{item.price}</div>
                                </div>
                              </div>
                            ))}
                          {selectedItems.length === 0 && (
                            <p className="text-sm text-gray-500">No items selected</p>
                          )}
                            </ul>
                          </div>

                          {/* Reminder */}
                          <div className="rounded-lg bg-gray-100 p-3">
                            <p className="font-medium text-gray-900">Returns Policy Reminder</p>
                            <p className="text-sm text-gray-600">
                              Processing may take up to 7 days
                            </p>
                            <label className="mt-2 flex items-center gap-2 text-sm text-gray-600">
                              <input type="checkbox" className="h-4 w-4 rounded-sm cursor-pointer border border-gray-300 checked:bg-[#558223] checked:border-[#558223] focus:outline-none focus:ring-0" />
                              I agree with the{" "}
                              <a href="#" className="text-green-700 underline">
                                Terms and Conditions
                              </a>
                            </label>
                          </div>
                        </div>

                        {/* Footer */}
                        <div className="mt-6 mb-8 flex justify-between">
                          <button
                            onClick={() => setIsOpen(false)}
                            className="rounded-md border px-6 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
                          >
                            Back
                          </button>
                          <button onClick={()=>setIsSubmitted(true)} className="w-fit px-4 flex items-center justify-center py-2 bg-[#558223] text-white font-medium hover:text-[#558223] hover:bg-transparent ring-[1.5px] ring-[#558223] hover:ring-[#558223] rounded-md">
                            Submit Request
                          </button>
                        </div>
                      </>
                        )}
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </div>
    </>
  );
};

export default RequestReturnsPage;



